// removed by extract-text-webpack-plugin
module.exports = {"calendar_container":"calendar_container","lesson_container":"lesson_container","time":"time","lesson_name":"lesson_name"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/CalendarDailyView/style.scss
// module id = TawE
// module chunks = 0